import React from 'react';
import { FaInstagram, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-title">ANGELIKA ERTA</h3>
            <p className="footer-subtitle">Photographer</p>
          </div>
          
          <div className="footer-social">
            {/* <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
            > */}
              {/* <FaInstagram size={20} /> */}
            {/* </a> */}
            <a 
              href="mailto: photo@angelikaertaphotography.com"
              className="social-link"
              aria-label="Email"
            >
              <FaEnvelope size={20} />
            </a>
          </div>
        </div>
        
        <div className="footer-divider"></div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Angelika Erta. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;